"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveEventType = void 0;
var DriveEventType;
(function (DriveEventType) {
    DriveEventType["NodeCreated"] = "node_created";
    DriveEventType["NodeUpdated"] = "node_updated";
    DriveEventType["NodeUpdatedMetadata"] = "node_updated_metadata";
    DriveEventType["NodeDeleted"] = "node_deleted";
    DriveEventType["ShareWithMeUpdated"] = "share_with_me_updated";
})(DriveEventType || (exports.DriveEventType = DriveEventType = {}));
//# sourceMappingURL=interface.js.map